"use strict";
var FromObservable_1 = require('./FromObservable');
exports.from = FromObservable_1.FromObservable.create;
//# sourceMappingURL=from.js.map


//////////////////
// WEBPACK FOOTER
// /app/~/rxjs/observable/from.js
// module id = ../../../../rxjs/observable/from.js
// module chunks = 18